import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import useIsMobile from "../hooks/useIsMobile";
import useSheetData from "../hooks/useSheetData";
import Reveal from "../components/common/Reveal";
import SectionTag from "../components/common/SectionTag";
import { SheetLoading, SheetEmpty } from "../components/common/SheetState";
import Seo from "../components/common/Seo";
import { colors, fonts, emphasis, sectionPad, maxW, springHover, rowShift } from "../styles/theme";

export default function CareersPage() {
  const mob = useIsMobile();
  const { data: OPENINGS, status } = useSheetData("Jobs");
  return (
    <div style={{ background: colors.paper, minHeight: "100vh", paddingTop: 74 }}>
      <Seo
        title="Careers | Charith"
        description="Open roles at Charith — join a team building web, cloud, and mobile products for real clients."
        path="/careers"
      />
      <section style={{ background: colors.paper, ...sectionPad(mob) }}>
        <Reveal style={{ ...maxW, maxWidth: 720 }}>
          <SectionTag>We're Hiring</SectionTag>
          <h1 style={{ fontFamily: fonts.display, fontWeight: 600, fontSize: mob ? 32 : "clamp(30px,4.2vw,54px)", lineHeight: 1.12, color: colors.ink, letterSpacing: "-.01em", marginBottom: 18 }}>Grow with <span style={emphasis}>Charith</span></h1>
          <p style={{ color: colors.inkDim, fontFamily: fonts.body, fontSize: mob ? 15 : 17, maxWidth: 480, lineHeight: 1.75 }}>
            We're building a world-class team. If you're passionate about technology and want to work on meaningful projects, we'd love to have you.
          </p>
        </Reveal>
      </section>
      <section style={{ background: colors.paper, padding: mob ? "0 6% 56px" : "0 6% 96px" }}>
        {status === "loading" ? (
          <div style={{ maxWidth: 860, margin: "0 auto", textAlign: "center" }}><SheetLoading label="Loading openings…" /></div>
        ) : status === "error" ? (
          <SheetEmpty icon="Briefcase" title="Couldn't load openings" message="We're unable to reach our job listings right now — please check back shortly or reach out directly." />
        ) : OPENINGS.length === 0 ? (
          <SheetEmpty icon="Briefcase" title="No open positions right now" message="We're not actively hiring at the moment, but we're always open to hearing from great people. Get in touch and we'll keep you in mind." />
        ) : (
          <div style={{ maxWidth: 860, margin: "0 auto", borderTop: `1px solid ${colors.borderStrong}` }}>
            {OPENINGS.map((o, i) => (
              <Reveal key={i} delay={i * 0.04}>
                <motion.div initial="rest" whileHover="hover" variants={rowShift} transition={springHover} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 14, padding: mob ? "20px 4px" : "24px 16px", borderBottom: `1px solid ${colors.border}` }}>
                  <div>
                    <h3 style={{ fontFamily: fonts.body, fontWeight: 700, fontSize: mob ? 15.5 : 17, color: colors.ink, marginBottom: 7 }}>{o.role}</h3>
                    <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                      {[o.type, o.loc, o.exp].map((t, j) => (
                        <span key={j} style={{ color: colors.inkFaint, fontFamily: fonts.body, fontSize: 12.5 }}>{j > 0 ? "· " : ""}{t}</span>
                      ))}
                    </div>
                  </div>
                  <motion.div whileHover={{ backgroundColor: colors.ink, color: colors.cream }} transition={springHover}>
                    <Link to="/contact" style={{ background: "none", border: `1.5px solid ${colors.ink}`, color: "inherit", fontFamily: fonts.body, fontWeight: 600, fontSize: 12.5, padding: "9px 18px", borderRadius: 3, whiteSpace: "nowrap", textDecoration: "none", display: "inline-block" }}>
                      Apply Now
                    </Link>
                  </motion.div>
                </motion.div>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
